// Title.styles.js

import styled from 'styled-components';

const Title2 = styled.h2`
    font-size: 1.8em;
    font-family: "Euclid";
    color: black;

    @media (max-aspect-ratio: 0.6/1) {
        font-size: 1.5em;
    }
`;

export default Title2;
